// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"729":"00e99c49","787":"d9e45e93","887":"3e7abbae"}[chunkId] + ".chunk.js";
};